/** Slugs used by public collection routes and New Arrivals filters */
export const PRODUCT_CATEGORY_TABS = ["all", "electronics", "fashion", "beauty", "home"];

const SLUG_FROM_CATEGORY_NAME = [
  { slug: "fashion", match: ["fashion", "cloth", "apparel", "wear"] },
  { slug: "beauty", match: ["beauty", "cosmetic", "fragrance", "skin"] },
  { slug: "home", match: ["home", "kitchen", "furniture", "decor"] },
  { slug: "electronics", match: ["electronic", "tech", "gadget", "audio"] },
];

/**
 * Map a product to a collection slug using API category name, then name/type hints.
 */
export function getProductCategorySlug(product) {
  const categoryName = (product?.category?.name || "").toLowerCase();
  for (const { slug, match } of SLUG_FROM_CATEGORY_NAME) {
    if (match.some((token) => categoryName.includes(token))) {
      return slug;
    }
  }

  const raw = `${product?.type || ""} ${product?.name || ""}`.toLowerCase();
  for (const { slug, match } of SLUG_FROM_CATEGORY_NAME) {
    if (match.some((token) => raw.includes(token))) {
      return slug;
    }
  }

  return null;
}

export function labelForCategorySlug(slug) {
  if (!slug || slug === "all") return "All";
  return slug.charAt(0).toUpperCase() + slug.slice(1);
}
